import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ChecklistModel } from '../../checklist.model';
import { saveAs } from 'file-saver';

@Component({
    selector: 'fi-checklist-qr-code-data-list',
    templateUrl: './checklist-qr-code-data-list.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FiChecklistQRCodeDataListComponent {
    @Input() checklist: ChecklistModel;

    constructor() {}

    hasQRCodes() {
        for (const checkpoint of this.checklist.CheckPoints) {
            if (checkpoint.CheckPresence) {
                return true;
            }
        }
        return false;
    }

    exportCodes() {
        const codes: string[] = [];

        for (const checkpoint of this.checklist.CheckPoints) {
            codes.push(`checkpoint-${this.checklist.Id}-${checkpoint.SortIndex}`);
        }

        const blob = new Blob([codes.join('\n')], {
            type: 'text/plain',
        });

        saveAs(blob, 'codes.txt');
    }
}
